import React from 'react';

function VideoIcon() {
  return (
    <svg className="video-icon" viewBox="0 0 63 41" xmlns="http://www.w3.org/2000/svg">
      <title>Video</title>
      <path d="M38.07 0H5.296C2.505 0 0 2.253 0 5.225v30.027c0 2.972 2.506 5.657 5.295 5.657H38.07c2.788 0 4.94-2.686 4.94-5.658V5.225C43.01 2.253 40.86 0 38.07 0zm8.85 11.996v12.767l15.64 7.964V4.09z" fillRule="evenodd"/>
    </svg>
  );
}

export default VideoIcon


// WEBPACK FOOTER //
// ./modules/Common/components/svg/VideoIcon.js